export default "__VITE_ASSET__C2MPq1zQ__"